<div class="autoComplete-assessor">
  <mat-form-field [floatLabel]="'never'" [ngClass]="{'input-invalid' : !hiddenInvalid}">

    <input spellcheck="false" (blur)="callBackWorksheet()" minlength="5" maxlength="12" matInput #autoInput type="text"
      class="active" [matAutocomplete]="issuingAsset" (keypress)="keyPressed($event)" (paste)="onPaste($event)"
      (keyup)="onAutoCompletAsset($event)" [(value)]="nameAutoComplete" [placeholder]="'Nome do cliente'"
      (keydown.enter)="onInputEnter($event)" ondragstart="return false;" ondrop="return false;" appAutosizeInput
      [minWidth]="80" [maxWidth]="36" [autoSizeActive]="autoSizeActive">

    <mat-autocomplete autoActiveFirstOption #issuingAsset id="issuingAsset" (optionSelected)='optionSelected($event)'
      [autoActiveFirstOption]="false" class="{{isWorksheet ?'worksheetClass' : ''}}">
      <mat-option *ngFor="let item of filteredAssets" [value]="item.full_name" (onSelectionChange)="onInputEnter($event)">
        {{item.full_name | uppercase }}</mat-option>
    </mat-autocomplete>

  </mat-form-field>
</div>